import type { PropsWithChildren, ReactNode } from 'react'

interface AppLayoutProps extends PropsWithChildren {
  tabBar:    ReactNode
  sidebar:   ReactNode
  canvas:    ReactNode
  statusBar: ReactNode
}

export function AppLayout({
  tabBar,
  sidebar,
  canvas,
  statusBar,
}: AppLayoutProps) {
  return (
    <div className="flex h-full min-h-0 flex-1 flex-col overflow-hidden font-mono text-[var(--text)]">
      {tabBar}
      <div className="flex min-h-0 flex-1 overflow-hidden">
        {sidebar}
        {canvas}
      </div>
      {statusBar}
    </div>
  )
}
